'use client';
import { objectKeys } from '../object.js';
import { isNonArrayObject } from '../../guards/isObject/isObject.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/** Производит глубокое слияние объектов. */ const deepMerge = (target, source)=>{
    if (!source) {
        return target;
    }
    const result = _extends({}, target);
    const _source = source;
    /* Использование isObjectExactly важно для корректной работы с массивами. */ const isObjectTarget = isNonArrayObject(target);
    if (isObjectTarget && isNonArrayObject(source)) {
        for (const key of objectKeys(source)){
            if (isNonArrayObject(_source[key])) {
                if (!(key in target)) {
                    result[key] = _source[key];
                } else {
                    result[key] = deepMerge(result[key], _source[key]);
                }
            } else {
                result[key] = _source[key];
            }
        }
    } else if (!isObjectTarget) {
        return source;
    }
    return result;
};

export { deepMerge };
//# sourceMappingURL=deepMerge.js.map
